<template>
  <div class="error-view">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      @click-left="back"
    >
      <i slot="left" class="iconfont icon-back"/>
      <span slot="title">
        {{$t('base.error')}}
      </span>
    </van-nav-bar>
    <div class="error-state">
      <i class="iconfont icon-prompt" />
      <p>{{$t('file.removed')}}</p>
      <router-link v-if="$route.name !== 'OpenView'" :to="`/${module}`" class="btn" replace>{{$t('base.back.home')}}</router-link>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'

export default {
  name: 'ErrorView',
  i18n,
  props: {
    module: String
  },
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.error-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & .file-header {
    flex: 0 0 auto
  }

  & .error-state {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & i {
      font-size: 56px;
      color: var(--contentIcon)
    }
  }

  & p {
    margin: 20px 0
  }

  & .btn {
    display: inline-block;
    min-width: 90px;
    height: 35px;
    line-height: 35px;
    border-radius: 2px;
    background-color: #fff;
    border: solid 1px #dbdcdd;
    text-align: center;
    font-size: 14px;
    color: #000
  }
}
</style>
